import { Label } from "@packages/ds";
import styled from "styled-components";

import {
  CloseButton as DsCloseButton,
  ButtonWrapper as DsButtonWrapper
} from "ds/Button";

export const PageContainer = styled.div`
  position: absolute;
  z-index: 997;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  height: auto;
  background-color: var(--section-snow-background-color, var(--snow));
  overflow-x: hidden;
`;

export const LogoWrapper = styled.div`
  display: block;
  margin: 32px 32px 8px;
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  max-width: 420px;
  padding: 0 32px;
  margin: 0 auto 128px auto;
  text-align: center;

  & > *:first-child {
    margin-bottom: 16px;
  }
`;

export const IconCloseButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CloseButton = styled(DsCloseButton)`
  margin-right: 24px;
  margin-top: 16px;
`;

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  & > div {
    width: 100%;
    text-align: left;
  }

  input {
    width: 100%;
  }
`;

export const InputWrapperV2 = styled(InputWrapper)`
  gap: unset;
`;

export const SimpleLabel = styled(Label)`
  margin-bottom: 0px;
`;

export const DialogWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LoadingContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  & > span {
    padding: 0;
  }
`;

export const ButtonWrapper = styled(DsButtonWrapper)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 32px;
  margin-top: 24px;
`;

export const StepperWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
`;
